<template>
  <el-card
    class="background"
    v-loading="loading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <el-collapse v-model="activeCollapses" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基础信息
          </div>
        </template>
        <div class="collapse-content">
          <formItem
            ref="baseInfoFormRef"
            :params="baseInfoData"
            :columns="getProcessedBaseColumns"
            :rules="baseRules"
            @changeValueHandler="changeValueHandler"
            @changeCompanyHandler="changeCompanyHandler"
            @changeDepartmentHandler="changeDepartmentHandler"
            labelWidth="120px"
          >
          </formItem>
          <el-form :model="baseInfoData">
            <el-form-item label="商机过程" prop="nicheProcess" label-width="120px">
              <el-input
                type="textarea"
                :maxlength="500"
                :disabled="disableNicheProcess"
                :rows="3"
                placeholder="请输入"
                v-model="baseInfoData.nicheProcess"
              >
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            意向空间
          </div>
        </template>
        <div class="collapse-content">
          <DesiredSpaceTable
            ref="desiredTableRef"
            :tableData="nicheIntentSpaces"
            :nicheCompanyNo="baseInfoData.nicheCompanyNo"
            :disabled="intentionSpacesDisabled"
            @handleTableChange="handleTableChange"
          ></DesiredSpaceTable>
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            跟进记录
          </div>
        </template>
        <div class="collapse-content">
          <FollowingRecordsTable
            ref="followingTableRef"
            :tableData="nicheFollowRecords"
            :disabled="followingRecordsDisabled"
            @handleTableChange="handleTableChange"
          ></FollowingRecordsTable>
        </div>
      </el-collapse-item>
      <el-collapse-item name="4" v-if="pageMode == 1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            签约信息
          </div>
        </template>
        <div class="collapse-content">
          <formItem
            ref="signInfoFormRef"
            :params="signInfoData"
            :columns="getSignInfoColumns"
            :rules="baseRules"
            labelWidth="120px"
          />
          <vxe-grid
            border
            show-overflow
            resizable
            ref="signUpSpacesTableRef"
            class="vxe-table-element"
            size="mini"
            align="center"
            :auto-resize="true"
            :data="nicheSignUpSpaces"
            :toolbar="{}"
            :valid-config="{}"
            :edit-config="{}"
            height="300"
          >
            <vxe-table-column
              v-for="(item, index) in getSignSpacesColumns"
              :key="index"
              :type="item.type"
              :fixed="item.fixed"
              :field="item.field"
              :title="item.title"
              :width="item.width"
            ></vxe-table-column>
          </vxe-grid>
        </div>
      </el-collapse-item>
    </el-collapse>
    <footer class="bottomButtons">
      <div style="padding: 20px; background: #fff" v-if="pageMode == 0 || pageMode == 2">
        <el-button type="primary" @click="btnClick('save')" class="fixed-bottom-btn"
          >保存
        </el-button>
        <el-button type="primary" @click="btnClick('cancel')" class="fixed-bottom-btn"
          >取消
        </el-button>
      </div>
    </footer>
  </el-card>
</template>

<script>
  import formItem from '../../../../intermodality/common/components/form-item.vue';
  import DesiredSpaceTable from './tables/DesiredSpaceTable.vue';
  import FollowingRecordsTable from './tables/FollowingRecordsTable.vue';
  import MerchantDetailMixin from '@/pages/property/merchants/merchantCenter/detail/mixins/MerchantDetailMixin';
  import MerchantDetailFormStatusMixin from '@/pages/property/merchants/merchantCenter/detail/mixins/MerchantDetailFormStatusMixin';

  export default {
    name: 'merchantCreate',
    mixins: [MerchantDetailMixin, MerchantDetailFormStatusMixin],
    components: {
      formItem,
      DesiredSpaceTable,
      FollowingRecordsTable,
    },
    mounted() {
      if (this.$route.query?.pageMode) {
        this.pageMode = Number(this.$route.query?.pageMode);
      }
      this.initDetail();
    },
    data() {
      return {
        loading: false,
        activeCollapses: ['1', '2', '3', '4'],
        pageMode: 0,

        // activeTabName: 'freightAndRouteDetailTab',
      };
    },
    computed: {},
    methods: {},
  };
</script>

<style lang="scss" scoped>
  .bottomButtons {
    padding-top: 20px;
    text-align: left;
  }
</style>
